import * as React from "react";
import * as API from "../../Utils/Services/api";
import EditAdminCoinModal from "./EditAdminCoinModal";
import { faEdit, faBan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useMemo, useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const labels = {
  0.5: "Useless",
  1: "Useless+",
  1.5: "Poor",
  2: "Poor+",
  2.5: "Ok",
  3: "Ok+",
  3.5: "Good",
  4: "Good+",
  4.5: "Excellent",
  5: "Excellent+",
};
function getLabelText(value) {
  return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
}

const AdminCoinTable = () => {
  const adminToken = localStorage.getItem("admin_token");
  const adminId = adminToken ? jwtDecode(adminToken).id : null;
  const [hover, setHover] = React.useState(-1);
  const [coins, setCoins] = useState([]);
  const [coin, setCoin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [editCoin, setEditCoin] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [editedCoin, setEditedCoin] = useState({});
  const [allAdminReviews, setAllAdminReviews] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [reviewModal, setReviewModal] = useState(false);
  const [selectedCoinForReview, setSelectedCoinForReview] = useState(null);
  const [newReviewText, setNewReviewText] = useState("");
  const [newReviewRating, setNewReviewRating] = useState(0);
  const [reviewSubmitted, setReviewSubmitted] = useState(false);
  const [viewReviewsModal, setViewReviewsModal] = useState(false);
  const [selectedCoinReviews, setSelectedCoinReviews] = useState([]);
  const [selectedCoinName, setSelectedCoinName] = useState("");
  const navigate = useNavigate();

  const handleEdit = async (row) => {
    setEditCoin(row);
    setEditModal(true);
  };

  // const handleToggleDisable = (id) => {
  //   setCoins((prevCoins) =>
  //     prevCoins.map((coin) =>
  //       coin.id === id ? { ...coin, disabled: !coin.disabled } : coin
  //     )
  //   );
  // };
  const fetchCoins = async () => {
    try {
      // const res = await fetch(
      //   `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&category=real-world-assets-rwa&order=market_cap_desc&per_page=50&page=1`
      // );
      // const data = await res.json();
      const res = await API.GetAllTokenAdmin({
        page,
        size: perPage,
        filter: "",
      });
      const data = await res.data.currency;
      const total = res.data.total || 0;
      const formattedData = data.map((coin) => ({
        id: coin.id,
        tokenId: coin.id,
        name: coin.name,
        image: coin.image,
        symbol: coin.symbol,
        current_price: coin.current_price,
        tokenImage: coin.image,
        description: coin.description || "",
        disabled: !coin.enable,
        last_updated: coin.last_updated,
        marketCap: coin.market_cap,
        rating: 0,
        reviews: allAdminReviews,
      }));
      setCoins(formattedData);
      setTotalItems(total);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching coins", err);
      setLoading(false);
    }
  };
  const handleToggleDisable = async (id) => {
    try {
      const targetCoin = coins.find((coin) => coin.id === id);
      const newStatus = !targetCoin.disabled;

      const response = await API.EnableDisableAdminCoin(id, {
        status: newStatus ? "disabled" : "enabled",
      });

      if (response.status === 200) {
        toast.success(
          `Coin ${newStatus ? "Disabled" : "Enabled"} Successfully`
        );
        await fetchCoins();
        setCoins((prevCoins) =>
          prevCoins.map((coin) =>
            coin.id === id ? { ...coin, disabled: newStatus } : coin
          )
        );
      } else {
        toast.error("Failed to update coin status:");
      }
    } catch (error) {
      toast.error("Error toggling status:");
    }
  };

  function formatMarketCap(value) {
    const num = Number(value);
    if (isNaN(num)) return "Invalid";

    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(2) + "B";
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M";
    } else {
      return num.toString();
    }
  }
  const paginatedCoins = useMemo(() => {
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return coins.slice(start, end);
  }, [coins, page, perPage]);

  const columns = [
    {
      name: "Coin",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol.toUpperCase(),
    },
    {
      name: "Price (USD)",
      selector: (row) => `$${row.current_price}`,
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.tokenImage}
          alt={row.name}
          width="30"
          height="30"
          style={{ borderRadius: "5px" }}
        />
      ),
    },
    {
      name: "Market Cap",
      selector: (row) => `$${formatMarketCap(row.marketCap).toLocaleString()}`,
    },
    // {
    //   name: "Description",
    //   cell: (row) => (
    //     <span title={row.description}>
    //       {row.description?.length > 60
    //         ? row.description.slice(0, 60) + "..."
    //         : row.description}
    //     </span>
    //   ),
    //   wrap: true,
    // },
    // {
    //   name: "Reviews",
    //   cell: (row) => (
    //     <Button
    //       variant="outline-primary"
    //       size="sm"
    //       disabled
    //       // onClick={(e) => {
    //       //   e.stopPropagation();
    //       //   localStorage.setItem("selectedCoin", JSON.stringify(row));
    //       //   window.open(`/admincoin/${row.id}`, "_blank");
    //       // }}
    //     >
    //       {row.reviews.length} Reviews
    //     </Button>
    //   ),
    // },
    // Review API
    // {
    //   name: "Review",
    //   cell: (row) => (
    //     <Button
    //       variant="outline-success"
    //       size="sm"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         setSelectedCoinForReview(row);
    //         setNewReviewText("");
    //         setReviewModal(true);
    //       }}
    //     >
    //       {allAdminReviews.length > 0
    //         ? allAdminReviews.map((rev, i) => <>{rev.value}</>)
    //         : "Add Review"}
    //     </Button>
    //   ),
    //   // ignoreRowClick: true,
    // },

    {
      name: "Review",
      cell: (row) => {
        const reviewEntry = allAdminReviews.find(
          (r) => r.tokenId.toLowerCase() === row.id?.toLowerCase()
        );

        const adminReview = reviewEntry?.review.find(
          (r) => r.userId === adminId
        );

        return (
          <Button
            variant="outline-success"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedCoinForReview(row);
              setNewReviewText(adminReview?.value || "");
              setNewReviewRating(adminReview?.rating || 0);
              setReviewModal(true);
            }}
          >
            {adminReview ? "Edit Review" : "Add Review"}
          </Button>
        );
      },
    },

    // {
    //   name: "Rating",
    //   cell: (row) => {
    //     const total = row.reviews.reduce((sum, r) => sum + (r.rating || 0), 0);
    //     const avg = row.reviews.length
    //       ? (total / row.reviews.length).toFixed(1)
    //       : "0.0";

    //     return (
    //       <Button
    //         variant="link"
    //         style={{
    //           fontWeight: "bold",
    //           color: "#0d6efd",
    //           textDecoration: "underline",
    //         }}
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           localStorage.setItem("selectedCoin", JSON.stringify(row));
    //           navigate(`/admincoin/${row.id}`, "_blank");
    //         }}
    //       >
    //         {row.reviews.length} Ratings
    //         {/* {avg} ★ */}
    //       </Button>
    //     );
    //   },
    //   sortable: true,
    // },

    {
      name: "Rating",
      cell: (row) => {
        const reviewEntry = allAdminReviews.find((r) => {
          return toKebabCase(r.tokenId) === toKebabCase(row.id);
        });

        const ratings = reviewEntry?.review || [];
        const ratedReviews = ratings.filter(
          (r) => typeof r.rating === "number" && !isNaN(r.rating)
        );
        const total = ratedReviews.reduce((sum, r) => sum + r.rating, 0);
        const avg = ratedReviews.length
          ? (total / ratedReviews.length).toFixed(1)
          : "0.0";

        return (
          <Button
            variant="link"
            style={{
              fontWeight: "bold",
              color: "#121212bf",
              textDecoration: "none",
            }}
            // onClick={(e) => {
            //   e.stopPropagation();
            //   localStorage.setItem("selectedCoin", JSON.stringify(row));
            //   navigate(`/admincoin/${row.id}`, "_blank");
            // }}
          >
            {/* {ratedReviews.length} */}
            {avg} <i className="fa-solid fa-star fa-xs"></i>
          </Button>
        );
      },
      sortable: true,
    },
    {
      name: "View Reviews",
      cell: (row) => {
        const reviewEntry = allAdminReviews.find(
          (r) => toKebabCase(r.tokenId) === toKebabCase(row.id)
        );

        const reviews = reviewEntry?.review || [];

        return (
          <Button
            variant="outline-info"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedCoinReviews(reviews);
              setSelectedCoinName(row.name);
              setViewReviewsModal(true);
              // localStorage.setItem("selectedCoin", JSON.stringify(row));
              // navigate(`/admincoin/${row.id}`, "_blank");
            }}
          >
            {reviews.length} Reviews
          </Button>
        );
      },
      ignoreRowClick: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <Button
            variant="link"
            onClick={() => handleEdit(row)}
            className={`me-2 ${row.disabled ? "bg-dark" : ""}`}
          >
            <FontAwesomeIcon icon={faEdit} />
          </Button>
          <Button
            variant="link"
            className={row.disabled ? "bg-dark text-danger" : "text-success"}
            onClick={() => handleToggleDisable(row.id)}
            title={row.disabled ? "Enable Coin" : "Disable Coin"}
          >
            <FontAwesomeIcon icon={faBan} />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  const customStyles = {
    table: {
      style: {
        // backgroundColor: "#7cc9fd00",
      },
    },
    header: {
      style: {
        backgroundColor: "#7cc9fd26",
      },
    },
    head: {
      style: {
        backgroundColor: "#7cc9fd26",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#7cc9fd26",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#7cc9fd26",
        fontWeight: "bold",
        color: "#333",
      },
    },
    rows: {
      style: {
        backgroundColor: "#7cc9fd26",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        backgroundColor: "#7cc9fd26",
        overflowWrap: "break-word",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#7cc9fd26",
        color: "#333",
        borderTop: "1px solid #ccc",
        padding: "10px",
      },
    },
  };
  const toKebabCase = (str) =>
    str &&
    str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");

  useEffect(() => {
    (async () => {
      const resp = await API.GetAllReviewsAdmin();
      if (resp.status && Array.isArray(resp.data.review)) {
        setAllAdminReviews(resp.data.review);
      } else {
        // console.log("Unexpected review data format", resp.data);
        setAllAdminReviews([]);
      }
    })();
  }, [reviewSubmitted]);

  useEffect(() => {
    fetchCoins();
  }, [perPage, page, allAdminReviews]);

  // useEffect(() => {
  //   const fetchUpdatedCoins = async () => {
  //     try {
  //       const updatedCoins = await Promise.all(
  //         coins.map(async (coin) => {
  //           const res = await API.GetUpdatedCoinDetails(coin.id); // Only ID, no data
  //           return {
  //             ...coin,
  //             ...res.data,
  //           };
  //         })
  //       );
  //       setCoins(updatedCoins);
  //     } catch (err) {
  //       console.error("Failed to fetch updated coin details:", err);
  //     }
  //   };

  //   fetchUpdatedCoins();
  // }, []); // run once on component mount
  const conditionalRowStyles = [
    {
      when: (row) => row.disabled,
      style: {
        backgroundColor: "#ffd3d3",
        color: "#fff",
      },
    },
  ];
  return (
    <div className="table-container">
      <DataTable
        title="All Coins"
        columns={columns}
        // data={paginatedCoins}
        data={coins}
        // highlightOnHover
        striped
        conditionalRowStyles={conditionalRowStyles}
        pagination
        paginationServer
        paginationTotalRows={totalItems}
        paginationPerPage={perPage}
        paginationDefaultPage={page}
        onChangePage={(page) => setPage(page)}
        onChangeRowsPerPage={(newPerPage, page) => {
          setPerPage(newPerPage);
          setPage(page);
        }}
        progressPending={loading}
        // pointerOnHover
        customStyles={customStyles}
      />
      {/* {console.log("___________________________", allAdminReviews)} */}

      <EditAdminCoinModal
        show={editModal}
        onHide={() => setEditModal(false)}
        coin={editCoin}
        onSave={(updated) => {
          setCoins((prev) =>
            prev.map((c) => (c.id === updated.id ? { ...c, ...updated } : c))
          );
        }}
      />

      <Modal show={reviewModal} onHide={() => setReviewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Admin Review </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Review</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={newReviewText}
                onChange={(e) => setNewReviewText(e.target.value)}
              />{" "}
            </Form.Group>{" "}
            <Form.Group className="mb-3">
              <Form.Label>Rating (optional)</Form.Label>
              {/* {HoverRating()} */}
              <Box sx={{ width: 200, display: "flex", alignItems: "center" }}>
                <Rating
                  name="hover-feedback"
                  value={newReviewRating}
                  precision={0.5}
                  getLabelText={getLabelText}
                  onChange={(e) =>
                    setNewReviewRating(parseFloat(e.target.value))
                  }
                  onChangeActive={(event, newHover) => {
                    setHover(newHover);
                  }}
                  emptyIcon={
                    <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                  }
                />
                {newReviewRating !== null && (
                  <Box sx={{ ml: 2 }}>
                    {labels[hover !== -1 ? hover : newReviewRating]}
                  </Box>
                )}
              </Box>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setReviewModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              // try {
              //   const data = {
              //     review: newReviewText,
              //     rating: newReviewRating,
              //     // coinId: allAdminReviews?.id,
              //   };
              //   const response = await API.AdminReviewAPI(
              //     allAdminReviews?.tokenId,
              //     data
              //   );
              //   if (response.status) toast.success("Review Added successfully");

              //   setReviewModal(false);
              try {
                const tokenId = selectedCoinForReview?.id;

                if (!tokenId) {
                  toast.error("Token ID missing!");
                  return;
                }

                const data = {
                  review: newReviewText,
                  rating: newReviewRating,
                };

                const response = await API.AdminReviewAPI(tokenId, data);
                if (response.status) {
                  setReviewSubmitted(true);
                  toast.success("Review Added successfully");
                  setTimeout(() => setReviewSubmitted(false), 400);
                }
                setReviewModal(false);
              } catch (err) {
                console.error(err);
                toast.error("Review failed to save");
              }
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* See reviews modal */}
      <Modal
        show={viewReviewsModal}
        onHide={() => setViewReviewsModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>All Reviews for {selectedCoinName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
          {selectedCoinReviews.length === 0 ? (
            <p>No reviews available for this coin.</p>
          ) : (
            selectedCoinReviews.map((review, index) => (
              <div key={index} style={{ marginBottom: "15px" }}>
                <div style={{ fontWeight: "bold" }}>
                  {review.username || "Anonymous"}:
                </div>
                <div style={{ marginBottom: "5px" }}>{review.value}</div>
                <div>
                  Rating:{" "}
                  <Rating
                    name="read-only"
                    value={review.rating}
                    precision={0.5}
                    readOnly
                    size="small"
                  />
                </div>
                <hr />
              </div>
            ))
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setViewReviewsModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminCoinTable;
